import React, {useState, useEffect} from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Bar, ResponsiveContainer, ComposedChart, ReferenceLine  } from "recharts";
import SingleSelectDropdown from "../../Dropdown/SingleSelectDropdown";
import { TabsNavigation, Tab } from "pepsico-ds";
import { generateSymmetricTicksAndDomain, generatePositiveIntegerTicksAndDomain } from "../ChartUtils";

const CustomizedTick = ({ x, y, payload }) => {
    return (
        <g transform={`translate(${x},${y})`}>
            <text
                fill="#616161"
                y={0}
                style={{ fontSize: "13px" }}
                x={5}
                transform="rotate(270)" // Rotate the text by 90 degrees
                textAnchor="end" // Align the text properly
                dy={5} // Adjust vertical alignment
            >
                {payload.value}
            </text>
        </g>
    );
};

const NpsLineBarChart = ({npsAdminLineBarChartData}) => {
  const sampleData = npsAdminLineBarChartData
  const granularityKeyMap = {
    "Weekly": "weeklyData",
    "Quarterly": "quarterlyData",
    "Monthly": "monthlyData",
    "Yearly": "yearlyData",
  }
  
  const [selectedTab, setSelectedTab] = useState(-1)
 // Determine the default chart data based on the granularity key
 let defaultChartData = [];
 if(npsAdminLineBarChartData){
  defaultChartData = sampleData[granularityKeyMap[sampleData?.granularityKey]]
 }
  
 // Initialize state with the appropriate data based on granularity
 const [chartData, setChartData] = useState(defaultChartData);

const CustomTooltip = ({ active, payload, label }) => {
  let tabValue = selectedTab == 1 ? 'Week' : selectedTab == 2 ? 'Quarter' : 
                 selectedTab == 3 ? 'Month' : selectedTab == 4 ? 'Year' : ''
  if (active && payload && payload.length) {
    return (
      <div style={{ backgroundColor: "#fff", padding: "10px", border: "1px solid #ccc" }}>
        <div style={{}}><strong>{tabValue}: {label}</strong></div>
        {payload.map((entry, index) => (
          <div key={index} 
            //  style={{ color: entry.color }}
          //  style={{marginBottom: '-5px'}}
          >
            <span style={{height: '12px', width: '12px', borderRadius: '50%', 
                          backgroundColor: entry.color, display: 'inline-block',
                          marginRight: '5px'}}>              
            </span>
            {entry.name}: {entry.value}
          </div>
        ))}
      </div>
    );
  }
  return null;
};


 useEffect(() => {
  if(sampleData){
    setChartData(sampleData[granularityKeyMap[sampleData?.granularityKey]]);

    const tabMap = {
      weeklyData: 1,
      quarterlyData: 2,
      monthlyData: 3,
      yearlyData: 4,
    };
  
    setSelectedTab(tabMap[granularityKeyMap[sampleData.granularityKey]] || 0);  
  }
 
}, [sampleData]);


const sortedData = [...chartData];


// // NEW: Positive integer ticks and domain generator
// function generatePositiveIntegerTicksAndDomain(maxValue, tickCount = 5) {
//   const domainMax = Math.ceil(maxValue); // round up to integer
//   const intervalCount = tickCount - 1;
//   const step = Math.ceil(domainMax / intervalCount); // integer step

//   const adjustedDomainMax = step * intervalCount; // ensure max is multiple of step
//   const domainMin = 0;

//   const ticks = [];
//   if(step !== 0){
//     for (let i = domainMin; i <= adjustedDomainMax; i += step) {
//       // ticks.push(i);
//       ticks.push(Number(i.toFixed(2)));
//     }
//   }
  
//   return { ticks, domainMin, domainMax: adjustedDomainMax };
// }

// Symmetric ticks and domain (same as before)
// function generateSymmetricTicksAndDomain(maxValue, tickCount = 9) {
//   const intervalCount = tickCount - 1;
//   const step = roundUpToNearest((2 * maxValue) / intervalCount, getRoundingBase(maxValue));
//   const domainMax = step * Math.floor(intervalCount / 2);
//   const domainMin = -domainMax;
//   const ticks = [];
//   if(step !== 0){
//     for (let i = domainMin; i <= domainMax; i += step) {
//       // ticks.push(i);
//       ticks.push(Number(i.toFixed(2)));
//     }
//   }
  
//   return { ticks, domainMin, domainMax };
// }


// ===== Main Tick & Domain Logic =====

// Your data input
const primaryValues = chartData?.flatMap(item => 
// const primaryValues = sampleData?.flatMap(item => 
  // parseFloat(item.newSKUs),
  parseFloat(item.responsesCount)
  // parseFloat(item.remodeledSKUs)
);


// const secondaryValues = sampleData?.map(item => parseFloat(item.npsScore));
const secondaryValues = chartData?.map(item => parseFloat(item.npsScore));
// const secondaryValues = sampleData?.map(item => parseFloat(item.opportunities));

// Raw min/max
const maxSecondaryValue = Math.max(...secondaryValues);
const minSecondaryValue = Math.min(...secondaryValues);
const maxPrimaryValue = Math.max(...primaryValues);
const minPrimaryValue = Math.min(...primaryValues);


const absMaxSecondary = Math.max(Math.abs(minSecondaryValue), Math.abs(maxSecondaryValue));
const absMaxPrimary = Math.max(Math.abs(minPrimaryValue), Math.abs(maxPrimaryValue));

// Determine if negative domain needed for BOTH based on either minPrimary or minSecondary
const needSymmetricDomain = (minPrimaryValue < 0 || minSecondaryValue < 0);

let {
  domainMax: primaryDomainMax,
  domainMin: primaryDomainMin,
  ticks: primaryTicks,
} = needSymmetricDomain
  ? generateSymmetricTicksAndDomain(absMaxPrimary)
  : generatePositiveIntegerTicksAndDomain(maxPrimaryValue);

let {
  domainMax: secondaryDomainMax,
  domainMin: secondaryDomainMin,
  ticks: secondaryTicks,
} = needSymmetricDomain
  ? generateSymmetricTicksAndDomain(absMaxSecondary)
  : generatePositiveIntegerTicksAndDomain(maxSecondaryValue);

if(absMaxPrimary == 0){
  primaryDomainMax = secondaryDomainMax
  primaryDomainMin = secondaryDomainMin
  primaryTicks = secondaryTicks
}

if(absMaxSecondary == 0){
  secondaryDomainMax = primaryDomainMax
  secondaryDomainMin = primaryDomainMin
  secondaryTicks = primaryTicks
}

  return (
    <>
    <div>
    <TabsNavigation
  className=""
  selectedIndex={selectedTab-1}
  style={{}}
>

  <Tab
    label="Weekly"
    onClick={function Xs() {setSelectedTab(1)
      setChartData(sampleData?.weeklyData)
    }}
  />

  <Tab
    label="Quarterly"
    onClick={function Xs() {setSelectedTab(2)
      setChartData(sampleData?.quarterlyData)
    }}
  />

  <Tab
    label="Monthly"
    onClick={function Xs() {setSelectedTab(3)
      setChartData(sampleData?.monthlyData)}}
  />
  <Tab
    label="Yearly"
    onClick={function Xs() {setSelectedTab(4)
      setChartData(sampleData?.yearlyData)}}
  />
</TabsNavigation>
    </div>
    <br/>
    {/* <div 
        style={{ width: '9rem', float: 'right', position: 'relative', bottom: '3rem' }}
        >
            <SingleSelectDropdown 
            className='buy-con-dropdown-modal' 
            childList={dropdownValue} label="" 
            // selectedValue={costLineHcmPlank} setSelectedValue={onDropdownChange} 
            />
       </div> */}
       
       <ResponsiveContainer width="100%" height={350}>
      <ComposedChart
        data={sortedData}
        margin={{
          top: 20,
          right: 10,
          left: 10,
          bottom: 50,
        }}
      >
        <CartesianGrid horizontal={true} vertical={false} stroke="#DFDFDF" />


        <YAxis
          yAxisId="right"
          orientation="right"
          axisLine={false}
          tickLine={false}
          allowDecimals={false}
          // domain={[0, maxSecondaryValue]}
          domain={[secondaryDomainMin, secondaryDomainMax]}
          // ticks={generateTicks(maxSecondaryValue)}
          ticks={secondaryTicks}
          // ticks={minSecondaryValue >= 0 ? generateTicks(maxSecondaryValue) : generateTicksNegative(maxSecondaryValue, minSecondaryValue)}
          interval={0}
          tick={({ x, y, payload }) => (
            <text x={x} y={y + 4} textAnchor="start" fill="#666">
              {payload.value}
            </text>
          )}
        //   label={{
        //     value: "Opportunity Identified (in $ MN)",
        //     angle: -90,
        //     position: "insideRight",
        //     textAnchor: "middle",
        //     dy: -120,
        //     dx: 8,
        //     style: { fontSize: "14px", fontWeight: "700", fill: "#616161"},
        //   }}
        />
        
        <ReferenceLine y={0} stroke="#888888" yAxisId="right" />
        {/* Primary Y Axis */}
        <YAxis
          yAxisId="left"
          axisLine={false}
          tickLine={false}
          allowDecimals={false}
          // domain={[0, maxPrimaryValue]}
          domain={[primaryDomainMin, primaryDomainMax]}
          ticks={primaryTicks}
          // ticks={generateTicks(maxPrimaryValue)}
          label={{
            value: "# of Response",
            angle: -90,
            position: "insideLeft",
            textAnchor: "middle",
            dy: 50,
            style: { fontSize: "14px", fontWeight: "700", fill: "#616161" },
          }}
        />


        <XAxis 
                  // dataKey="month" 
                  dataKey="metricName" 
                  tickLine={false} 
                  tick={<CustomizedTick />} 
                  name="Month"
                  interval={0}
                />


  {/* <ReferenceLine y={0} stroke="#000" strokeDasharray="3 3" yAxisId="right" /> */}

        <Tooltip content={<CustomTooltip />} />

        {/* One Bar */}
        <Bar
          yAxisId="left"
          // dataKey="opportunities"
          dataKey="responsesCount"
          name="Response"
          // name="Opportunities Identified"
          barSize={20}
          fill="#0078A7"
        //   radius={[4, 4, 0, 0]}
        />
        {/* Two Lines */}
        <Line
          yAxisId="right"
          type="linear"
          dataKey="npsScore" //responsesCount
          // dataKey="newSKUs"
          // name="New SKUs"
          name="NPS Score"
          stroke="#B05788"
          dot={{ fill: "#B05788", stroke: "#B05788", strokeWidth: 2 }}
          strokeWidth={3}
        />
        {/* <Line
          yAxisId="left"
          type="linear"
          dataKey="remodeledSKUs"
          name="Re-modeled SKUs"
          stroke="#B05788"
          dot={{ fill: "#B05788", stroke: "#B05788", strokeWidth: 2 }}
          strokeWidth={3}
        /> */}

        
      </ComposedChart>
    </ResponsiveContainer>
    </>
    
  );
};

export default NpsLineBarChart;
